import React, { useState } from "react";
import { Table, Image, Button } from "react-bootstrap";
import BasicPagination from "../../../../../Pagination/Pagination";
import ViewEventDetailsOffline from "./ViewEventDetailsOffline";
import ViewEventDetailsOnline from "./ViewEventDetailsOnline";
import moment from "moment";
import { NOTAVAILABLEIMAGE } from "../../../../../../enums/GlobalEnums";

const EventsFavoritesInsidePage = (props) => {
  //state

  const [page, setPage] = useState(1);
  const [showView, setShowView] = useState(false);
  const [showView2, setShowView2] = useState(false);
  const handleCloseView = () => setShowView(false);

  const [modalData, setModalData] = useState();
  const handleShowView = (offerData) => {
    setModalData(offerData);
    setShowView(true);
  };
  const handleCloseView2 = () => setShowView2(false);
  const handleShowView2 = () => setShowView2(true);

  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };
  return (
    <>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
        <Table className="enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <td style={{ width: "20%" }} className="f12-500">
                Restaurant <br /> Name
              </td>
              <td style={{ width: "25%" }} className="f12-500">
              Experience
              </td>
              {/* <th style={{ width: "12%" }} className="f12-700">
                Viewed
              </th>
              <th style={{ width: "12%" }} className="f12-700">
                Used
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                Coupon Code
              </th> */}
              {/* <td style={{ width: "20%" }} className="f12-500">
                Start - End Date
              </td> */}
              <td style={{ width: "20%" }} className="f12-500">
                Date / Time
              </td>
              <td style={{ width: "25%" }} className="f12-500 ml-3">
                Status
              </td>
            </tr>
          </thead>
          {props.allEvents.slice(start, end).map((event, index) => (
            <tbody className="HideShowTable" key={index}>
              <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
                <td style={{ width: "20%" }}>
                  <div className="d-flex flex-column align-items-start">
                    <div className="enImage45 ">
                      <Image
                        //src={require("../../../../../../assets/images/UserManagement/fhr7.png")}
                        src={
                          event?.eventId?.restaurant_id?.logo_url ||
                          NOTAVAILABLEIMAGE
                        }
                        alt="View"
                        title="View"
                        fluid
                      />
                    </div>
                    <div className="f11-500 text-center mt-1">
                      {event?.eventId?.restaurant_id?.restaurant_name}
                    </div>
                  </div>
                </td>
                <td style={{ width: "25%" }}>
                  <div className="d-flex align-items-center">
                    <div className="text-center d-flex flex-column align-items-center">
                      <div className="enIMG62">
                        <Image
                          src={
                            event?.eventId?.photos[0] ||
                            require("../../../../../../assets/images/UserManagement/offer.png")
                          }
                          alt="View"
                          title="View"
                          fluid
                        />
                      </div>
                      <div
                        className={
                          event?.eventId.isOnline
                            ? "enSuccessLBL"
                            : "enPendingLBL mt-2"
                        }
                      >
                        {event?.eventId.isOnline ? "Online" : "Offline"}
                      </div>
                    </div>
                    <div className="pl-3">
                      <div className="f14-500">{event?.eventId?.name}</div>
                    </div>
                  </div>
                </td>
                {/* <td style={{ width: "12%" }}>
                  <div className="f14-500">
                    {" "}
                    {event.eventViews >= 1 ? <> Yes</> : <>No </>}
                  </div>
                  <div className="f9-400">04-07-2020</div>
                  <div className="f9-400">12:30 PM</div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f14-500">
                    {" "}
                    {event.eventUsed >= 1 ? <> Yes</> : <>No </>}
                  </div>
                  <div className="f9-400">04-07-2020</div>
                  <div className="f9-400">12:30 PM</div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f14-500">{event.coupon_code}</div>
                </td> */}
                {/* <td style={{ width: "20%" }}>
                  <div className="f14-400">
                    {moment(event.start_date).format("ll")} -
                  </div>{" "}
                  -
                  <div className="f14-400 text-red">
                    {moment(event.end_date).format("ll")}
                  </div>
                </td> */}
                <td style={{ width: "20%" }}>
                  <div className="f14-700">
                    {moment(event.createdAt).format("Do MMM, YYYY")} 
                  </div>
                  <div className="f14-700">
                    {moment(event.createdAt).format("LT")}
                  </div>
                </td>
                <td style={{ width: "25%" }}  className="flexcenter">
                  <>
                    {event.message === "Favourite was removed" ? (
                      <div className="f13-400 mx-2">
                        <span className="enRedDot mr-1"></span>
                        {event.message}
                      </div>
                    ) : (
                      <div className="f13-400 mx-2">
                        <span className="enGreenDot mr-1"></span>
                        {event.message}
                      </div>
                    )}
                  </>
                  <Button
                    variant="link"
                    className="enIconBtn mr-3"
                    onClick={() => handleShowView(event)}
                  >
                    <Image
                      src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </Button>
                </td>
              </tr>
            </tbody>
          ))}
          {/* <tbody className="HideShowTable">
            <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
              <td style={{ width: "13%" }}>
                <div className="d-flex flex-column align-items-start">
                  <div className="enImage45 ">
                    <Image
                      src={require("../../../../../../assets/images/UserManagement/fhr7.png")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </div>
                  <div className="f11-500 text-center mt-1">McDonald</div>
                </div>
              </td>
              <td style={{ width: "28%" }}>
                <div className="d-flex align-items-center">
                  <div className="text-center d-flex flex-column align-items-center">
                    <Image
                      src={require("../../../../../../assets/images/UserManagement/offer.png")}
                      alt="View"
                      title="View"
                      fluid
                    />
                    <div className="enSuccessLBL mt-2">Online</div>
                  </div>
                  <div className="pl-3">
                    <div className="f14-500">Pune comedy festival</div>
                  </div>
                </div>
              </td>
              <td style={{ width: "12%" }}>
                <div className="f14-500">Yes</div>
                <div className="f9-400">04-07-2020</div>
                <div className="f9-400">12:30 PM</div>
              </td>
              <td style={{ width: "12%" }}>
                <div className="f14-500">No</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f14-500">LS1245</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f14-400">25th Feb 20 -</div>
                <div className="f14-400 text-red">25th Mar 20</div>
              </td>
              <td style={{ width: "10%" }}>
                <Button variant="link" className="enIconBtn mr-3 mb-3" onClick={handleShowView2}>
                  <Image
                    src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                    alt="Edit"
                    title="Edit"
                    fluid
                  />
                </Button>
              </td>
            </tr>
          </tbody> */}
        </Table>
      </div>
      {props.allEvents.length !== 0 ? (
        <BasicPagination
          totalRecords={props.allEvents.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <></>
      )}
      <ViewEventDetailsOffline
        onClickCloseView={handleCloseView}
        onClickshowView={showView}
        event={modalData?.eventId}
      />
      <ViewEventDetailsOnline
        onClickCloseView={handleCloseView2}
        onClickshowView={showView2}
      />
    </>
  );
};

export default EventsFavoritesInsidePage;
